import { render, staticRenderFns } from "./LeaveApproval.vue?vue&type=template&id=61405ae8&scoped=true"
import script from "./LeaveApproval.vue?vue&type=script&lang=js"
export * from "./LeaveApproval.vue?vue&type=script&lang=js"
import style0 from "./LeaveApproval.vue?vue&type=style&index=0&id=61405ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61405ae8",
  null
  
)

export default component.exports